import { Type } from '@angular/core';
import { Route, Routes } from '@angular/router';

import { QuestionType } from './question-type';
import { WoodConditionImage } from './wood-condition-image.model';
import { WoodGrainImage } from './wood-grain-image.model';
import { WoodLookImage } from './wood-look-image.model';
import { PopupImage } from './popup-image.model';
import { ProductRecommendationText } from './product-recommendation-text.model';
import { WoodType } from './wood-type';
import { Question, Answer, AnswerConfirmation, Modal } from './qa.model';

export interface BrandInfo {
    BrandLogoImage: string;
    BrandLogoImageAlt: string;
    BackgroundImage: string;
    BottomImage: string;
    BottomImageAlt: string;
    ApplicationLogoImageAlt: string;
    ApplicationLogoImage: string;
    GoBackTranslation: string;
    BackTranslation: string;
    NextQuestionTranslation: string;
    GtmProperty: string;
    GtmLanguage: string;
    GtmBrandName: string;
    GrabbingWoodType: string;
    GeneratingProjectImage: string;
    SimulatingColors: string;
    ViewResultsTranslation: string;
    GotItTranslation: string;
    CloseModalTranslation: string;
    RedirectToHomeTranslation: string;
    CloseWarningTranslation: string;
    WarningTitleTranslation: string;
    EliteModalTitle: string;
    EliteModalText: string;
    EliteModalImage: string;
    EliteModalButtonText: string;
    WaterguardModalTitle: string;
    WaterguardModalText: string;
    WaterguardModalImage: string;
    WaterguardModalButtonText: string;
}
export interface Tile {
    NewWindow: boolean;
    Href: string;
    Image: string;
    ImageAlt: string;
    Title: string;
  Subtitle: string;
  ArticleFilter: string;
}

export interface Product{
    NodeName: string;
    NodeAlias: string;
    NodeId: string;
    Image: string;
    ProductFilter: string;
    DisplayName: string;
    DocumentPageTitle: string;
    DocumentPageDescription: string;
    DocumentPageKeyWords: string;
}
export interface ProductScreen {
    Color: string;
    EmailButtonText: string;
    EmailButtonHref: string;
    StoreButtonText: string;
    StoreButtonHref: string;
    BuyOnlineButtonText: string;
    BuyOnlineButtonHref: string;
    OurRecommendationLabel: string;
    HeaderText: string;
    FirstName: string;
    LastName: string;
    Tiles: Tile[];
    EmailModalTitle: string;
    EmailModalActionFailure: string;
    EmailModalActionSuccess: string;
    EmailModalEmailPlaceholder: string;
    EmailModalRegionPlaceholder: string;
    EmailModalLegalNote : string;
    EmailModalRegions:DropdownValue[];
    EmailModalButtonText: string;
}

export interface DropdownValue{
    Value:string;
    Text:string;
}

export interface WelcomeScreen {
    BackgroundImage: string;
    Headline: string;
    ButtonText: string;
    Part1Image: string;
    Part2Image: string;
    Part3Image: string;
    Part1Headline: string;
    Part2Headline: string;
    Part3Headline: string;
    Part1Description: string;
    Part2Description: string;
    Part3Description: string;
    DocumentPageTitle: string;
    DocumentPageDescription: string;
    DocumentPageKeyWords: string;
    DescribeYourProject: string;
    VisualizeYourProject: string;
    GetYourProjectGuide: string;
}

export interface PostalCodeScreen {
    Headline: string;
    Description: string;
    InputPlaceholder: string;
    ButtonText: string;
    SkipThisQuestionText: string;
    InvalidPostalMessage: string;
    PostalCodePattern: string;
    DocumentPageTitle: string;
    DocumentPageDescription: string;
    DocumentPageKeyWords: string;
    Progress:string;
}

export interface AppData {
  BrandInfo: BrandInfo;
  ProductScreen:ProductScreen;
  WelcomeScreen: WelcomeScreen;
  PostalCodeScreen: PostalCodeScreen;
  //Loader: Loader;
  Routes: RouteFromKetico[];
  QuestionTypes: QuestionType[];
  WoodConditionImages: WoodConditionImage[];
  WoodGrainImages: WoodGrainImage[];
  WoodLookImages: WoodLookImage[];
  PopupImages: PopupImage[];
  ProductRecommendationText: ProductRecommendationText[];
  WoodTypes: WoodType[];
  ProductValueDescriptions: ProductValueDescription[];
  ArticleLinks: ArticleLinks[];
  ArticleTypes: ArticleType[];
  Questions: Question[];
  Answers: Answer[];
  AnswerConfirmations: AnswerConfirmation[];
  Modals: Modal[];
  BuyOnlineLinks: BuyOnlineLink[];
}


export class RouteFromKetico implements Route {
    name: string;
    path?: string;
    component?: Type<any>;
    redirectTo?: string;
}

export class ProductValueDescription {
  OpacityFilter: string;
  ProjectFilter: string;
  ProductQualityFilter: string;
  Description: string;
  Culture: string;
}

export class ArticleLinks {
  ProjectFilter: string;
  OpacityFilter: string;
  WoodTypeFilter: string;
  WhatLookFilter: string;
  ArticleFilter: string;
  ArticleUrl: string;
  Culture: string;
}

export enum ArticleTypeEnum {
  StepByStep = "Step-By-Step",
  Video = "Video",
  ShoppingList = "Shopping List",
  Calculator = "Calculator"
}

export class ArticleType {
  ItemName: string;
  ItemGUID: string;
}

export class BuyOnlineLink {
  ProductName: string;
  ColorName: string;
  Opacity: string;
  Store: string;
  BuyUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/models/data.model.ts